import SVGCheckbox from "../../icons/Checkbox.svg?react";
import SVGCheckboxOutlineBlank from "../../icons/CheckboxOutlineBlank.svg?react";
import styles from "./CheckBox.module.css";
import Icon from "./Icon";

interface Props {
  label: string;
  isSelected: boolean;
  onChange: (b: boolean) => void;
}

const Checkbox = ({ label, isSelected, onChange }: Props) => (
  <div className={styles.checkbox} onClick={() => onChange(!isSelected)}>
    <Icon glyph={isSelected ? SVGCheckbox : SVGCheckboxOutlineBlank} />
    <label>{label}</label>
  </div>
);

export default Checkbox;
